import React from 'react';

const GlobalStyles = () => (
    <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;0,800;1,800&display=swap');
    
    :root {
        /* Nueva Paleta de Colores Dark & Gold */
        --bg-main: #171717;
        --bg-card: #252525;
        --bg-darker: #0F0F0F;
        
        /* Dorado Naranja Premium */
        --gold-primary: #F59E0B;
        --gold-light: #fbbf24;
        --gold-dark: #b45309;
        --gold-brushed: linear-gradient(135deg, #F59E0B 0%, #D97706 50%, #B45309 100%);
        --gold-glow: 0 0 20px rgba(245, 158, 11, 0.3);
        
        /* Textos */
        --text-white: #FFFFFF;
        --text-grey: #a3a3a3;
        --accent-orange: #F59E0B;
        
        /* Espaciado y Bordes */
        --border-radius-lg: 20px;
        --border-radius-md: 12px;
        --border-radius-sm: 8px;
        
        --header-height: 72px;
        --bottom-nav-height: 70px;
    }

    * { 
        margin: 0; 
        padding: 0; 
        box-sizing: border-box; 
        font-family: 'Outfit', 'Inter', sans-serif; 
        -webkit-tap-highlight-color: transparent; 
    }
    
    body {
        background: var(--bg-main);
        color: var(--text-white);
        min-height: 100vh;
        overflow-x: hidden;
        overscroll-behavior-y: none;
    }

    .gold-gradient {
        background: var(--gold-brushed);
    }

    .main-layout {
        padding-top: var(--header-height);
        padding-bottom: calc(var(--bottom-nav-height) + 40px);
        min-height: 100vh;
        width: 100%;
        max-width: 100vw;
    }

    @media (min-width: 1024px) {
        .main-layout {
            padding-left: 260px;
            padding-bottom: 40px;
            padding-right: 340px;
            max-width: 1440px;
            margin: 0 auto;
        }
    }

    ::-webkit-scrollbar { width: 5px; height: 5px; }
    ::-webkit-scrollbar-track { background: var(--bg-main); }
    ::-webkit-scrollbar-thumb { background: var(--bg-card); border-radius: 10px; }
    ::-webkit-scrollbar-thumb:hover { background: var(--gold-primary); }
    
    .no-scrollbar::-webkit-scrollbar { display: none; }
    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes slideUp { 
        0% { transform: translateY(30px); opacity: 0; } 
        100% { transform: translateY(0); opacity: 1; }
    }
    @keyframes pulse {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.5; transform: scale(1.1); }
        100% { opacity: 1; transform: scale(1); }
    }

    .animate-fade-in { animation: fadeIn 0.4s ease-out; }
    .animate-slide-up { animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1); }
    .animate-pulse-live { animation: pulse 2s infinite; }

    .card-navy {
        background: var(--bg-card);
        border: 1px solid rgba(255, 255, 255, 0.05);
        box-shadow: 0 10px 30px rgba(0,0,0,0.2);
    }

    .btn-gold {
        background: var(--gold-brushed);
        color: #000;
        font-weight: 800;
        text-transform: uppercase;
        box-shadow: 0 4px 15px rgba(245, 158, 11, 0.25);
        transition: all 0.3s ease;
    }
    .btn-gold:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
    }
    .btn-gold:active {
        transform: translateY(0);
    }
  `}</style>
);

export default GlobalStyles;
